import React, {Component} from 'react'
import SkuPage from "./SkuPage"

class SkuContainer extends Component {
    render() {
        return (
            <div className="SkuContainer">
                <SkuPage/>
            </div>
        )
    }
}

export default SkuContainer